import React from 'react';
import BpoServicesHero from '../components/BpoServicesHero';
import Counters from '../components/Counters';
import BpoCustomerExperience from '../components/BpoCustomerExperience';
import BpoServicesTabs from '../components/BpoServicesTabs';
import WhyChooseBpo from '../components/WhyChooseBpo';
import BpoFeaturesCards from '../components/BpoFeaturesCards';
import BpoTestimonialsSlider from '../components/BpoTestimonialsSlider';
import PartnerLogos from '../components/PartnerLogos';
import IndustryGrid from '../components/IndustryGrid';
import ContactUs from '../components/ContactUs';

function BpoServicesPage() {
  return (
    <>
      <BpoServicesHero />
      <Counters />
      <BpoCustomerExperience />
      <BpoServicesTabs />
      <WhyChooseBpo />
      <PartnerLogos />
      <BpoFeaturesCards />
      <BpoTestimonialsSlider />
      <IndustryGrid />
      <ContactUs />
    </>
  );
}

export default BpoServicesPage;
